var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwlName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8588,
    height: 1050,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3218",
    gradientUnits: "userSpaceOnUse",
    x1: 74.2,
    y1: 543.5,
    x2: 74.2,
    y2: 396.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearG02link"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "stop00",
    style: {
      stopColor: "#1C6A51",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    id: "stop02",
    style: {
      stopColor: "#381E10",
      stopOpacity: 1
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3228",
    gradientUnits: "userSpaceOnUse",
    x1: 167.4,
    y1: 268.1,
    x2: 308.4,
    y2: 268.1
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3127",
    gradientUnits: "userSpaceOnUse",
    x1: 637.2,
    y1: 599.1,
    x2: 498.9,
    y2: 669.7
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3125",
    gradientUnits: "userSpaceOnUse",
    x1: 500.5,
    y1: 356,
    x2: 346.3,
    y2: 304.2
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3123",
    gradientUnits: "userSpaceOnUse",
    x1: 370.2,
    y1: 613.4,
    x2: 192.2,
    y2: 671.3
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3183",
    gradientUnits: "userSpaceOnUse",
    x1: 84.2,
    y1: 533.6,
    x2: 84.2,
    y2: 668.2
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3207",
    gradientUnits: "userSpaceOnUse",
    x1: 202.2,
    y1: 465.8,
    x2: 100.9,
    y2: 465.8
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3205",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2,
    y1: 537.4,
    x2: 75.2,
    y2: 718.9
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3203",
    gradientUnits: "userSpaceOnUse",
    x1: 79.7,
    y1: 388.1,
    x2: 79.7,
    y2: 236.9
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient4354",
    gradientUnits: "userSpaceOnUse",
    x1: 38.3,
    y1: 402.4,
    x2: 133.8,
    y2: 272.1
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient4356",
    gradientUnits: "userSpaceOnUse",
    x1: 233,
    y1: 600.6,
    x2: 366.2,
    y2: 600.6
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3159",
    gradientUnits: "userSpaceOnUse",
    x1: 343.8,
    y1: 554.6,
    x2: 211.1,
    y2: 618.7
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3184",
    gradientUnits: "userSpaceOnUse",
    x1: 328.1,
    y1: 390.5,
    x2: 279.7,
    y2: 489.5
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3197",
    gradientUnits: "userSpaceOnUse",
    x1: 182.9,
    y1: 451.2,
    x2: 61.7,
    y2: 451.2
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3186",
    gradientUnits: "userSpaceOnUse",
    x1: 87.5,
    y1: 381.5,
    x2: 87.5,
    y2: 268.2
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient4346",
    gradientUnits: "userSpaceOnUse",
    x1: 561.9,
    y1: 397.8,
    x2: 561.9,
    y2: 231.9
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient4348",
    gradientUnits: "userSpaceOnUse",
    x1: 410.1,
    y1: 565.8,
    x2: 269.6,
    y2: 642.3
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient4350",
    gradientUnits: "userSpaceOnUse",
    x1: 60.6,
    y1: 302.1,
    x2: 184.9,
    y2: 250.1
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3185",
    gradientUnits: "userSpaceOnUse",
    x1: 211.2,
    y1: 400.6,
    x2: 211.2,
    y2: 256.6
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3163",
    gradientUnits: "userSpaceOnUse",
    x1: 250.6,
    y1: 590.5,
    x2: 377.4,
    y2: 560.3
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3161",
    gradientUnits: "userSpaceOnUse",
    x1: 347.2,
    y1: 342.2,
    x2: 211.1,
    y2: 297.4
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearG02link",
    id: "linearGradient3658",
    gradientUnits: "userSpaceOnUse",
    x1: 73.1,
    y1: 405.2,
    x2: 73.1,
    y2: 538.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 237 733 C 111.1 733 10.5 614.1 10.5 467.5 l 61.5 -4.5 58.5 4.5 c 0 82.8 48.5 150 106.5 150 l 7.5 56.1 z  ",
    id: "pat1-001O100",
    transform: "translate(25,25)",
    style: {
      fill: "url(#linearGradient3218)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 237 316 c -58 0 -105 68.7 -105 151.5 L 9 467.5 C 9 320.9 111.1 203.5 237 203.5 l 6 51.6 z  ",
    id: "pat1-000O100",
    transform: "translate(25,25)",
    style: {
      fill: "url(#linearGradient3228)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 342 467.5 c 0 -82.8 -47 -150 -105 -150 v -115.5 c 125.9 0 228 118.9 228 265.5 0 146.6 -102.1 265.5 -228 265.5 L 231 677.4 237 617.5 c 58 0 105 -67.2 105 -150 z  ",
    id: "pat0-00O100",
    transform: "translate(25,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 481.5 730 144 -525 h 123 L 598.5 730 h -117 z  ",
    id: "pat1-002W101",
    transform: "translate(463,25)",
    style: {
      fill: "url(#linearGradient3127)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 463.5 730 318 205 h 118.5 l 144 525 h -117 z  ",
    id: "pat1-000W101",
    transform: "translate(463,25)",
    style: {
      fill: "url(#linearGradient3125)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 288 730 h -118.5 l 145.5 -525 h 121.5 z  ",
    id: "pat1-001W101",
    transform: "translate(463,25)",
    style: {
      fill: "url(#linearGradient3123)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 273 730 H 151.5 L 1.5 205 h 129 z  ",
    id: "pat0-00W101",
    transform: "translate(463,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21 727 0 -522 120 0 0 522 z  ",
    id: "pat1-000L102",
    transform: "translate(1213,25)",
    style: {
      fill: "url(#linearGradient3183)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18 613 340.5 0 0 117 -340.5 0 z  ",
    id: "pat0-00L102",
    transform: "translate(1213,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81 406 h 240 v 117 H 81 v -117 z  ",
    id: "pat1-002E104",
    transform: "translate(1781.5,25)",
    style: {
      fill: "url(#linearGradient3207)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 727 21 467.5 74.5 463 141 467.5 141 727 z  ",
    id: "pat1-000E104",
    transform: "translate(1781.5,25)",
    style: {
      fill: "url(#linearGradient3205)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21 467.5 0 -259.5 120 0 0 259.5 -63.5 4.5 z  ",
    id: "pat1-001E104",
    transform: "translate(1781.5,25)",
    style: {
      fill: "url(#linearGradient3203)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18 205 h 340.5 v 117 H 18 v -117 z m 0 408 h 340.5 v 117 H 18 v -117 z  ",
    id: "pat0-00E104",
    transform: "translate(1781.5,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21,730 V 208 H 135 V 730 H 21 z ",
    id: "pat1-001n105",
    transform: "translate(2149,25)",
    style: {
      fill: "url(#linearGradient4354)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 157.5,205 231,525 h -120 L 90,319 H 18 V 205 h 139.5 z ",
    id: "pat1-000n105",
    transform: "translate(2149,25)",
    style: {
      fill: "url(#linearGradient4356)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 291,730 V 205 H 405 V 730 H 291 z ",
    id: "pat0-00n105",
    transform: "translate(2149,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 381 205 h 124.5 L 316.5 730 h -121.5 z  ",
    id: "pat1-000V106",
    transform: "translate(2575,25)",
    style: {
      fill: "url(#linearGradient3159)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 205 H 129 L 316.5 730 H 190.5 z  ",
    id: "pat0-00V106",
    transform: "translate(2575,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 730 V 205 H 141 V 730 H 21 z  ",
    id: "pat0-00I107",
    transform: "translate(3082,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 216 415 c 33.1 0 60 -25.5 60 -57 0 -21.5 -16.4 -39 -33 -39 L 238.4 265 246 205 c 82.5 0 150 67.5 150 150 0 74.5 -74.7 120 -157.5 120 l -52.5 -60 h 30 z  ",
    id: "pat1-000R108",
    transform: "translate(3244,25)",
    style: {
      fill: "url(#linearGradient3184)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 201 514 -177 0 0 -99 162 0 16.9 52.1 z  ",
    id: "pat1-001R108",
    transform: "translate(3244,25)",
    style: {
      fill: "url(#linearGradient3197)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21 730 0 -522 120 0 0 522 z  ",
    id: "pat1-002R108",
    transform: "translate(3244,25)",
    style: {
      fill: "url(#linearGradient3186)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 243 319 -225 0 0 -114 228 0 4.5 58.5 z m -57 96 c 105 0 210 78.8 210 157.5 l 0 157.5 -120 0 0 -141 c 0 -42 -33 -75 -75 -75 l -14.6 -46.9 z  ",
    id: "pat0-00R108",
    transform: "translate(3244,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 733 C 111.1 733 10.5 614.1 10.5 467.5 l 61.5 -4.5 58.5 4.5 c 0 82.8 48.5 150 106.5 150 l 7.5 56.1 z  ",
    id: "pat1-001O109",
    transform: "translate(3652,25)",
    style: {
      fill: "url(#linearGradient3218)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 237 316 c -58 0 -105 68.7 -105 151.5 L 9 467.5 C 9 320.9 111.1 203.5 237 203.5 l 6 51.6 z  ",
    id: "pat1-000O109",
    transform: "translate(3652,25)",
    style: {
      fill: "url(#linearGradient3228)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 342 467.5 c 0 -82.8 -47 -150 -105 -150 v -115.5 c 125.9 0 228 118.9 228 265.5 0 146.6 -102.1 265.5 -228 265.5 L 231 677.4 237 617.5 c 58 0 105 -67.2 105 -150 z  ",
    id: "pat0-00O109",
    transform: "translate(3652,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21,730 V 208 H 135 V 730 H 21 z ",
    id: "pat1-001n110",
    transform: "translate(4126,25)",
    style: {
      fill: "url(#linearGradient4354)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 157.5,205 231,525 h -120 L 90,319 H 18 V 205 h 139.5 z ",
    id: "pat1-000n110",
    transform: "translate(4126,25)",
    style: {
      fill: "url(#linearGradient4356)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 291,730 V 205 H 405 V 730 H 291 z ",
    id: "pat0-00n110",
    transform: "translate(4126,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 504 730 0 -522 117 0 0 522 z  ",
    id: "pat1-001m111",
    transform: "translate(4552,25)",
    style: {
      fill: "url(#linearGradient4346)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 424.5 205 h 199.5 v 114 H 507 L 382.5 730 h -118.5 z  ",
    id: "pat1-000m111",
    transform: "translate(4552,25)",
    style: {
      fill: "url(#linearGradient4348)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 730 V 205 H 138 V 730 H 21 z  ",
    id: "pat1-002m111",
    transform: "translate(4552,25)",
    style: {
      fill: "url(#linearGradient4350)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219 205 382.5 730 H 261 L 100.5 205 h 118.5 z  ",
    id: "pat0-00m111",
    transform: "translate(4552,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81 406 h 240 v 117 H 81 v -117 z  ",
    id: "pat1-002E112",
    transform: "translate(5194,25)",
    style: {
      fill: "url(#linearGradient3207)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 727 21 467.5 74.5 463 141 467.5 141 727 z  ",
    id: "pat1-000E112",
    transform: "translate(5194,25)",
    style: {
      fill: "url(#linearGradient3205)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21 467.5 0 -259.5 120 0 0 259.5 -63.5 4.5 z  ",
    id: "pat1-001E112",
    transform: "translate(5194,25)",
    style: {
      fill: "url(#linearGradient3203)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18 205 h 340.5 v 117 H 18 v -117 z m 0 408 h 340.5 v 117 H 18 v -117 z  ",
    id: "pat0-00E112",
    transform: "translate(5194,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21,730 V 208 H 135 V 730 H 21 z ",
    id: "pat1-001n113",
    transform: "translate(5561.5,25)",
    style: {
      fill: "url(#linearGradient4354)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 157.5,205 231,525 h -120 L 90,319 H 18 V 205 h 139.5 z ",
    id: "pat1-000n113",
    transform: "translate(5561.5,25)",
    style: {
      fill: "url(#linearGradient4356)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 291,730 V 205 H 405 V 730 H 291 z ",
    id: "pat0-00n113",
    transform: "translate(5561.5,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 268.5 208 0 522 -123 0 0 -522 z  ",
    id: "pat1-000T114",
    transform: "translate(5987.5,25)",
    style: {
      fill: "url(#linearGradient3185)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6 316 v -111 h 400.5 v 111 H 6 z  ",
    id: "pat0-00T114",
    transform: "translate(5987.5,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 97.5 517 h 315 v 105 H 97.5 v -105 z  ",
    id: "pat1-000A115",
    transform: "translate(6316,25)",
    style: {
      fill: "url(#linearGradient3163)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 196.5 205 h 129 l 180 525 h -127.5 z  ",
    id: "pat1-001A115",
    transform: "translate(6316,25)",
    style: {
      fill: "url(#linearGradient3161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 309 205 129 730 H 1.5 L 181.5 205 h 127.5 z  ",
    id: "pat0-00A115",
    transform: "translate(6316,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21 727 0 -522 120 0 0 522 z  ",
    id: "pat1-000L116",
    transform: "translate(6823,25)",
    style: {
      fill: "url(#linearGradient3183)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18 613 340.5 0 0 117 -340.5 0 z  ",
    id: "pat0-00L116",
    transform: "translate(6823,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 730 V 205 H 141 V 730 H 21 z  ",
    id: "pat0-00I118",
    transform: "translate(7391.5,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21,730 V 208 H 135 V 730 H 21 z ",
    id: "pat1-001n119",
    transform: "translate(7553.5,25)",
    style: {
      fill: "url(#linearGradient4354)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 157.5,205 231,525 h -120 L 90,319 H 18 V 205 h 139.5 z ",
    id: "pat1-000n119",
    transform: "translate(7553.5,25)",
    style: {
      fill: "url(#linearGradient4356)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 291,730 V 205 H 405 V 730 H 291 z ",
    id: "pat0-00n119",
    transform: "translate(7553.5,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9 467.5 c 0 -146.6 104.8 -265.5 234 -265.5 78 0 138 31.5 178.5 82.5 l -90.2 74.7 C 310.4 331 279.1 317.5 243 317.5 181.7 317.5 132 384.7 132 467.5 l -63 13.5 z  ",
    id: "pat1-000C120",
    transform: "translate(7979.5,25)",
    style: {
      fill: "url(#linearGradient3658)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 132 467.5 c 0 82.8 49.7 150 111 150 36.1 0 67.4 -13.5 88.3 -41.7 L 421.5 650.5 C 381 701.5 321 733 243 733 113.8 733 9 614.1 9 467.5 h 123 z  ",
    id: "pat0-00C120",
    transform: "translate(7979.5,25)",
    style: {
      fill: "#1C6A51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9 737.5 v -135 h 132 v 135 H 9 z  ",
    id: "pat0-00period121",
    transform: "translate(8413,25)",
    style: {
      fill: "#1C6A51"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwlName);
export default __webpack_public_path__ + "static/media/OwlName.a519e4ec90e42474c489fcf6a9c7dbaa.svg";
export { ForwardRef as ReactComponent };